import { render, staticRenderFns } from "./donutChart2.vue?vue&type=template&id=2ec48739"
import script from "./donutChart2.vue?vue&type=script&lang=js"
export * from "./donutChart2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports